import * as React from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import Main from './components';
import store from './store';
import history from './store/history';

function App() {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Main />
      </Router>
    </Provider>
  );
}

export default App;
